export default function mapEntityPositions(entities: string[]) {
  return entities.reduce(
    (acc: { [x: string]: number }, val: string | number, i) => {
      acc[val] = i
      return acc
    },
    {},
  )
}
